import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { MessageService } from '../shared/service/message.service';
import { VsCrudService } from '../shared/service/vs-crud.service';
import { Dashboard, DashboardPcp } from './dashboard.model';
import { Resultado } from '../shared/util/resultado.model';

@Injectable()
export class DashboardService extends VsCrudService<Dashboard> {
  
    public url: string = "api/dashboard";

    constructor(_http: HttpClient, _message: MessageService) { 
        super(<any>_http, _message);
    }
   
    public totalVendasRealizadas(lojaId: Number, periodo: Array<String>) {        
        return this.get(`${this.url}/totaisDashboard/${lojaId}/${periodo}`).toPromise().then(res => 
              <Dashboard>res);     
    }

    public consultarCertificado(lojaId: Number) {        
        return this.get(`${this.url}/certificado/${lojaId}`).toPromise().then(res => 
              <Resultado>res);     
    }

    public carregarDashboardPcp(dataInicio?: string, dataFim?: string): Observable<DashboardPcp> {
        let endpoint = `${this.url}/pcp`;
        if (dataInicio && dataFim) {
            endpoint += `?dataInicio=${dataInicio}&dataFim=${dataFim}`;
        }
        return this.get(endpoint) as Observable<DashboardPcp>;
    }
}


